import { render, staticRenderFns } from "./Page404.vue?vue&type=template&id=720c660d"
import script from "./Page404.vue?vue&type=script&lang=ts"
export * from "./Page404.vue?vue&type=script&lang=ts"
import style0 from "./Page404.vue?vue&type=style&index=0&id=720c660d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports